export const formatPercentage = (value: number | null | undefined): string => {
    if (value === null || value === undefined) return '';
    return `${value.toFixed(2).replace('.', ',')} %`;
};
